import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { startDeleteAppNotification, startFetchAppNotifications } from 'redux/alert/alert-actions'
import { RootState } from 'redux/store'

import BaseAlertComponent from '../AlertVariants/Base'
import { IAppNotification } from '../types'

import { parseTextToLinks } from './utils'

const Notifications = () => {
    const dispatch = useDispatch()

    const { currentUser } = useSelector((state: RootState) => state.user)
    const { appNotifications } = useSelector((state: RootState) => state.alert)

    useEffect(() => {
        dispatch(startFetchAppNotifications())
    }, [currentUser])

    const renderAlerts = () =>
        appNotifications?.map((notification: IAppNotification) => {
            const parsedMessage = parseTextToLinks(notification.message)

            return (
                <BaseAlertComponent
                    key={notification.id}
                    severity={notification.severity}
                    dismissable={notification.canBeDismissed}
                    onDismiss={() => dispatch(startDeleteAppNotification(notification.id))}
                    message={parsedMessage}
                    title={notification.title}
                />
            )
        })

    return <>{renderAlerts()}</>
}

export default Notifications
